
import Vue from 'vue'
import attachModule from '@/connectors/houses/attach-module'
import detachModule from '@/connectors/houses/detach-module'
import showManOrg from '@/connectors/managing-organization/show-managing-organization'
import { IHouse } from '@/types/houses'
import Loader from '@/components/Loader.vue'

export default Vue.extend({
  name: 'AttachModulesWizard',
  components: { Loader },
  data () {
    return {
      loader: false,
      chatModule: '',
      requestsModule: '',
      parkingRequestModule: '',
      house: {
        stringAddress: ''
      } as IHouse
    }
  },
  mounted () {
    this.showHouse()
  },
  methods: {
    showHouse () {
      this.loader = true
      showManOrg(Number(localStorage.getItem('moid')), 0, 1)
        .then(response => {
          console.log('attachModules', response)
          this.house = response.houses[0]
          this.loader = false
        }).catch(e => {
          this.loader = false
          console.error(e)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    // Подключаем или отключаем модули
    checkModule (value, module) {
      if (value) {
        attachModule(this.house.id, this.house.managingOrganizationId, module)
          .then((res) => {
            console.log(res)
          }).catch(e => {
            console.error(e)
            // @ts-ignore
            this.$showErrorToast(e.response.data.message)
          })
      } else {
        detachModule(this.house.id, this.house.managingOrganizationId, module)
          .then((res) => {
            console.log(res)
          }).catch(e => {
            console.error(e)
            // @ts-ignore
            this.$showErrorToast(e.response.data.message)
          })
      }
    }
  }
})
